import t from 'tcomb';

export default function getUUID(): t.String {
  const chars = '0123456789abcdef'.split(''),
    id = [],
    rnd = Math.random;
  let r;

  id[8] = id[13] = id[18] = id[23] = '-';
  id[14] = '4';
  for (let i = 0; i < 36; i++) {
    if (!id[i]) {
      r = 0 | rnd() * 16;
      id[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r & 0xf];
    }
  }
  return id.join('');
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/getUUID.js
 **/